import { Category } from "@/lookups/types/Lookup";

export const SAFETY_VALVE_LOOKUP_TABS_DICTIONARY: {
  [tabKey: string]: {
    key: Category;
    label: string;
  }[];
} = {
  "Valve Data": [
    {
      key: "Manufacturer",
      label: "Manufacturer",
    },
    {
      key: "Orifice",
      label: "Orifice",
    },
    {
      key: "Inlet",
      label: "Inlet",
    },
    {
      key: "Outlet",
      label: "Outlet",
    },
    {
      key: "Unit",
      label: "Unit",
    },
    {
      key: "CapType",
      label: "Cap Type",
    },
    {
      key: "Service",
      label: "Service",
    },
    {
      key: "Bonnet",
      label: "Bonnet",
    },
    {
      key: "BellowsMat",
      label: "Bellows Mat",
    },
    {
      key: "BodyMaterial",
      label: "Body Material",
    },
    {
      key: "SoftSeat",
      label: "Seat Material",
    },
  ],
  "Pre Test Data": [
    {
      key: "MaintenanceFor",
      label: "Maintenance For",
    },
    {
      key: "Staff",
      label: "Technicians",
    },
    {
      key: "PreTestNotes",
      label: "Pre Test Notes",
    },
  ],
  Parts: [
    {
      key: "Condition",
      label: "Condition",
    },
    {
      key: "Action",
      label: "Action Taken",
    },
    {
      key: "Recommendation",
      label: "Recommendation",
    },
  ],
  "Final Test": [
    {
      key: "TestMedia",
      label: "Test Media",
    },
    {
      key: "SetPointDefinition",
      label: "Set Point Definition",
    },
  ],
};

export const MANUAL_VALVE_LOOKUP_TABS_DICTIONARY: {
  [tabKey: string]: {
    key: Category;
    label: string;
  }[];
} = {
  "Valve Data": [
    {
      key: "ManualValveRepairReportType",
      label: "Type",
    },
    {
      key: "ManualValveRepairReportManufacturer",
      label: "Manufacturer",
    },
    {
      key: "ManualValveRepairReportBody",
      label: "Body",
    },
    {
      key: "ManualValveRepairReportSeatTrim",
      label: "Seat Trim",
    },
    {
      key: "ManualValveRepairReportDiscTrim",
      label: "Disc Trim",
    },
  ],
  "Final Test": [
    {
      key: "ManualValveRepairReportTestStandard",
      label: "Test Standard",
    },
  ],
};
